export interface Validator {
  caption?: string;
  validatorFn: (val: string) => boolean | '';
}

export const validate = (
  validators: Validator[],
  value: string,
): Array<ReturnType<Validator['validatorFn']>> =>
  validators.map((validator) => validator.validatorFn(value));

export const allValid = (validatorsState: (boolean | '')[]): boolean =>
  validatorsState.every((state) => state);

export const validators: Validator[] = [
  {
    caption: 'common:login.form.password-validator-min',
    validatorFn: (val: string) => val && val.length >= 8,
  },
  {
    caption: 'common:login.form.password-validator-uppercase',
    validatorFn: (val: string) => /^(?=.*[A-Z]).*$/.test(val),
  },
  {
    caption: 'common:login.form.password-validator-lowercase',
    validatorFn: (val: string) => val && /^(?=.*[a-z]).*$/.test(val),
  },
  {
    validatorFn: (val: string) => (val ? val.length <= 64 : true),
    caption: 'common:login.form.password-validator-maxlength',
  },
];
